export default {
  namespaced: true,

  state() {
    return {
      batches: null,
      flowType: null,
      pathTag: null,
    };
  },

  mutations: {
    update(state, { key, value }) {
      state[key] = value;
    },
  },
};
